import React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { trackMetaEvent } from '../utils/MetaPixel';

const Success = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(15);
  const [courseData, setCourseData] = useState(null);

  useEffect(() => {

    const storedData = localStorage.getItem("courseData");
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      setCourseData(parsedData);

      // 🔹 Dispara el evento cuando los datos están listos
      trackMetaEvent('Purchase', {
        value: parsedData.course_price,
        currency: parsedData.course_currency,
        content_name: parsedData.course_name,
        content_ids: [parsedData.course_id],
        status: 'success'
      });
      if (!parsedData.send_inscription) {
        const apiUrlSendEmailAcademy = `${process.env.REACT_APP_HOST_BACKEND}/send_inscription`;
        parsedData.student.paymentProof = null;

        const sendEmailInscriptionAcademy = async () => {
          try {
            // Crear un objeto FormData
            const formDataToSend = new FormData();
            Object.entries(parsedData.student).forEach(([key, value]) => {
              formDataToSend.append(key, value);
            });

            await fetch(apiUrlSendEmailAcademy, {
              method: "POST",
              body: formDataToSend,
              mode: 'cors'
            });
          } catch (error) {
            alert("Hubo un problema al enviar la inscripción.");
          }
        }
        sendEmailInscriptionAcademy();
      }
      const apiUrlSendEmailStudent = `${process.env.REACT_APP_HOST_BACKEND}/send_inscription_student`;
      parsedData.student.paymentProof = null;

      const sendEmailInscriptionStudent = () => {
        try {
          // Crear un objeto FormData
          const formDataToSend = new FormData();
          parsedData.student.course_name = parsedData.course_name
          parsedData.student.course_type_title = parsedData.course_type_title
          Object.entries(parsedData.student).forEach(([key, value]) => {
            formDataToSend.append(key, value);
          });

          fetch(apiUrlSendEmailStudent, {
            method: "POST",
            body: formDataToSend,
            mode: 'cors'
          });
        } catch (error) {
          alert("Hubo un problema al enviarle el correo de inscripción al estudiante.");
        }
      }
      sendEmailInscriptionStudent();
    }
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1500);

    setTimeout(() => {
      navigate("/courses");
    }, 20000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#111827',
      padding: '1rem',
      color: 'white',
      overflow: 'hidden'
    }}>
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.7, ease: "easeOut" }}
        style={{
          position: 'relative',
          zIndex: 10,
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
          backdropFilter: 'blur(16px)',
          padding: '2rem',
          borderRadius: '1rem',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
          maxWidth: '32rem',
          width: '100%',
          textAlign: 'center',
          border: '1px solid rgba(255, 255, 255, 0.2)'
        }}
      >
        {/* --- Icono de Éxito Animado --- */}
        <motion.div style={{ margin: '0 auto 1.5rem auto', height: '6rem', width: '6rem' }}>
          <svg viewBox="0 0 52 52">
            <motion.circle
              cx="26"
              cy="26"
              r="25"
              fill="none"
              stroke="#34D399"
              strokeWidth="4"
              initial={{ pathLength: 0 }}
              animate={{ pathLength: 1 }}
              transition={{ duration: 0.8, ease: "easeInOut" }}
            />
            <motion.path
              d="M14 27l8 8 16-16"
              fill="none"
              stroke="#FFFFFF"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
              initial={{ pathLength: 0, opacity: 0 }}
              animate={{ pathLength: 1, opacity: 1 }}
              transition={{ duration: 0.5, ease: "easeOut", delay: 0.8 }}
            />
          </svg>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 1.2 }}
          style={{ fontSize: '2.25rem', fontWeight: 'bold', color: 'white', marginBottom: '0.5rem' }}
        >
          ¡Inscripción Enviada!
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 1.4 }}
          style={{ fontSize: '1.125rem', color: '#D1D5DB', marginBottom: '1.5rem' }}
        >
          ¡Felicidades, <span style={{ fontWeight: '600', color: '#4ADE80' }}>{courseData?.student.fullName || "Estudiante"}</span>! Has dado el primer paso.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 1.6 }}
          style={{ backgroundColor: 'rgba(255, 255, 255, 0.1)', padding: '1rem', borderRadius: '0.5rem', border: '1px solid rgba(255, 255, 255, 0.2)' }}
        >
          <p style={{ color: 'white' }}>
            Validaremos tu pago y en las próximas 24 horas te llegará un correo electrónico para brindarte todos los detalles de ingreso a este {courseData?.course_type_title || "curso"}. 📚✨
          </p>
          <p style={{ fontSize: '0.875rem', color: '#9CA3AF', marginTop: '0.25rem' }}>
            Revisa tu bandeja de entrada (y spam) después de 24 horas. 🚀
          </p>
        </motion.div>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 1.8 }}
          style={{ marginTop: '2rem', color: '#9CA3AF', fontSize: '0.875rem' }}
        >
          Serás redirigido en <span style={{ fontWeight: 'bold', color: 'white' }}>{countdown}</span> segundos...
        </motion.p>
      </motion.div>
    </div>
  );
};

export default Success;

